import { render, staticRenderFns } from "./Favorite.vue?vue&type=template&id=6c554c4c&scoped=true"
import script from "./Favorite.vue?vue&type=script&lang=js"
export * from "./Favorite.vue?vue&type=script&lang=js"
import style0 from "./Favorite.vue?vue&type=style&index=0&id=6c554c4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c554c4c",
  null
  
)

export default component.exports